// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { rem } from '../../tokens/conversions';
import { borderRadius } from '../../tokens/spacing';
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { tablePaginationColors } from './tablePaginationColors';
export var TablePagination = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var c = tablePaginationColors(mode);
    var override = {
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    color: c.text,
                    fontSize: rem(12),
                    lineHeight: rem(16)
                },
                toolbar: {
                    minHeight: 'auto',
                    padding: 0,
                    gap: rem(12)
                },
                selectLabel: {
                    fontSize: rem(12),
                    lineHeight: rem(16)
                },
                displayedRows: {
                    fontSize: rem(12),
                    lineHeight: rem(16)
                },
                input: {
                    backgroundColor: bg.level0,
                    border: "".concat(rem(1), " solid ").concat(bd.heavy),
                    borderRadius: rem(borderRadius.tiny),
                    height: rem(36),
                    minWidth: rem(72),
                    boxSizing: 'border-box',
                    marginLeft: 0,
                    marginRight: 0
                },
                select: {
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    paddingLeft: rem(12),
                    paddingRight: "".concat(rem(32), " !important"),
                    display: 'flex',
                    alignItems: 'center'
                },
                actions: {
                    display: 'flex',
                    gap: rem(8),
                    marginLeft: 0
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=TablePagination.js.map